<template>
  <div class="">
    <Card class="">
      <template #title> Müşteri Grupları</template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="_GrupModal()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="GrupListesi" v-on:set-child-data="getDataChild"
          :editbutton="true" />
      </template>
    </Card>

    <Dialog v-model:visible="GrupModal" header="Müşteri Grup" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :style="{ width: '25vw' }" modal>

      <div class="formgrid grid ">
        <div class="field col md:col-6">
          <label for="GrupAd" class="font-bold block">Grup Ad</label>
          <InputText id="GrupAd" type="text" v-model="GrupAd" :invalid="this.Valid.GrupAd"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6">
          <label for="GrupTip" class="font-bold block">Tip</label>
          <Select name="GrupTip" v-model="GrupTip" :options="GrupTipListesi" optionLabel="Ad" optionValue="Tip"
            checkmark :highlightOnSelect="true" fluid :invalid="this.Valid.GrupTip" />

        </div>
        <div class="field col md:col-12">
          <label for="GrupAciklama" class="font-bold block">Grup Açıklama</label>
          <Textarea id="GrupAciklama" v-model="GrupAciklama" :invalid="this.Valid.GrupAciklama" rows="2" cols="30"
            class="text-base text-color w-full" />
        </div>
      </div>
      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
          @click="this.handleClick()" autofocus />
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
          @click="this._GrupModal()" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import DataTable from "../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../services/GlobalServis";

export default {
  data() {
    return {
      DataTable_render: true,
      GrupListesi: [],
      GrupTipListesi: [
        { Ad: "Müşteri", Tip: "M" },
        { Ad: "Satıcı", Tip: "S" }
      ],
      columns: [
        { field: "Ad", header: "Grup Ad" },
        { field: "Tip", header: "Grup Tip" },
        { field: "Aciklama", header: "Aciklama" },
      ],
      GrupModal: false,
      GrupModelDurum: null,

      GrupAd: "",
      GrupAciklama: "",
      Grup_rowid: null,
      GrupTip: "",
      //--------------
      // Validation Elements
      Valid: {
        GrupAd: false,
        GrupAciklama: false,
        GrupTip: false
      }
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.ResetForm();
      this.GrupModal = !this.GrupModal;
      this.GrupModelDurum = false;
      this.Grup_rowid = getdata_child.data.Grup_rowid;
      let data = {
        Grup_rowid: getdata_child.data.Grup_rowid,
      };
      GlobalServis.GlobalServis("POST", "GetGrupInfo", data).then((res) => {
        if (res.status == 200) {
          this.GrupAd = res.data[0].GrupAd;
          this.GrupAciklama = res.data[0].Aciklama;
          this.GrupKod = res.data[0].Grup_rowid;
          this.GrupTip = res.data[0].Tip;

        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _GrupModal() {
      this.GrupModelDurum = true;
      this.GrupModal = !this.GrupModal;
      if (this.GrupModal === true) {
        this.ResetForm();
      }
    },
    handleClick() {
      if (this._FormCheck()) { return; }

      let data = {
        Grup_rowid: this.Grup_rowid,
        GrupAd: this.GrupAd,
        GrupAciklama: this.GrupAciklama,
        Tip: this.GrupTip
      };
      if (this.GrupModelDurum) {
        // Yeni Kullanıcı

        GlobalServis.GlobalServis("POST", "SetGrup", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Grup oluşturulmuştur",
              life: 3000,
            });
            this.Refresh();
            this._GrupModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });
      } else {
        // Edit Grup
        GlobalServis.GlobalServis("POST", "UpdateGrup", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Grup düzenlemiştir",
              life: 3000,
            });
            this.Refresh();
            this._GrupModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });

      }
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
    ResetForm() {
      this.GrupAd = "";
      this.GrupAciklama = "";
      this.Grup_rowid = null;
    },
    InitServis() {
      GlobalServis.GlobalServis("GET", "GetGrupTablosu", "").then((res) => {
        if (res.status == 200) {
          this.GrupListesi = res.data;
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
      });
    },
    _FormCheck() {
      let Check = false;
      if (this.GrupAd === "" || this.GrupAd === null) {
        this.Valid.GrupAd = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Müşteri grup adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.GrupAd = false; Check = false; }

      if (this.GrupAciklama === "") {
        this.Valid.GrupAciklama = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Açıklama girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.GrupAciklama = false; Check = false; }

      return Check;
    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },

};
</script>